module.exports = __webpack_public_path__ + "static/media/sound_fold.c0973175.wav";